/**
 * Returns true if JWT token is found in localStorage, false otherwise.
 */
export const isAuthenticated = (): boolean => {
    return !!localStorage.getItem('jwtToken');
};


export const getAdminUidFromToken = (): string => {
    const token = localStorage.getItem('jwtToken');
    if (!token) return 'ADMIN_SUPPORT'; // Fallback

    try {
        // Decode the JWT Payload (Part 2 of the token)
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        const payload = JSON.parse(jsonPayload);

        // Return userId from payload (matches your backend req.user.userId)
        return payload.userId || payload.uid || payload.sub || 'ADMIN_SUPPORT';
    } catch (error) {
        console.error("Failed to decode token", error);
        return 'ADMIN_SUPPORT';
    }
};